import React from 'react';
const IconMiscSteps1 = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3 10.78L5 10.28V17H7V7.72L3 8.72V10.78Z" fill="#2D2E2E"/>
<path d="M21 5H12V7H21V5Z" fill="#2D2E2E"/>
<path d="M21 11H12V13H21V11Z" fill="#2D2E2E"/>
<path d="M21 17H12V19H21V17Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconMiscSteps1;